import React, { Component } from 'react';
import { Table, Row, InputNumber, Col, Button, DatePicker, message, Spin, Select, Input } from 'antd';
import moment from 'moment';
import imgSave from "../../saveImg";
import { data2_1 } from './data';
import Auth from "../../Auth";

const { MonthPicker } = DatePicker;
const Option = Select.Option;
const { TextArea } = Input;

Number.prototype.toFixed = function (exponent) {
    if (this > 0) {
        return parseInt(this * Math.pow(10, exponent) + 0.5) / Math.pow(10, exponent);
    } else {
        return parseInt(this * Math.pow(10, exponent) - 0.5) / Math.pow(10, exponent);
    }
}

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            loading: true,
            loadingSave: false,
            note: {
                note: ""
            },
            print: false
        }
    }


    componentDidMount() {
        this.getDateData(this.state.date);
    }

    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
    }

    getDateData = (date, isLastMonth) => {
        const dataBegin = JSON.stringify(data2_1);
        let data = JSON.parse(dataBegin);
        if (isLastMonth) {
            date = moment(date).subtract(1, 'month').format('YYYY-MM');
            if (this.state.data.some(x => x.id)) return message.error('当月数据已存在，无法填充！');
            this.setState({ data: [], loading: true });
        }
        fetch(`/_6_5_all?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data.dataNow && x.data.dataNow.length > 0) {
                data = x.data.dataNow;
            }
            if (isLastMonth) {
                data = data.map(x => { delete x.id; return x });
            }
            this.setState({ loading: false, data });

        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = this.state.data.map(x => ({ ...x, year, month }));
        let dataFrom = new FormData();
        if (this.state.note.note) {
            this.onSaveNote([{ ...this.state.note, year, month }])
        }

        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/add_6_3', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getDateData(date);
                }
                return
            }

            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    onSaveNote = (data) => {
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/add_6_3_1', headres).then(x => x.json()).then(x => {
            if (x.status == 1) {
                if (!this.state.note.id) {
                    this.getDateData(this.state.date);
                }
                return
            }
            message.error('备注保存失败：' + x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            message.error('保存失败！');
            console.error(err);
        })
    }

    onChangeSelect = (name, value) => {
        let data = this.state.data;
        data[0][name] = value.key;
        this.setState({
            data
        });
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table6_3', 1.5, '6.30', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });
    }
    render() {
        const data = this.state.data;
        const width = document.body.offsetWidth > 2425 ? document.body.offsetWidth - 2000 : 425;

        const totalData = [8, 12, 13];
        const columns = [{
            align: "center",
            title: <div></div>,
            dataIndex: 'name',
            key: 'name',
            width,
            render: (text, record, index) => {
                return (
                    <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`} style={{ textAlign: "left" }}>
                        {text}
                    </div>
                )
            }
        }, {
            title: 'Action Plan for Next 3months',
            dataIndex: 'Comments',
            key: 'Comments',
            align: "center",
            render: (text, record, index) => {
                return (
                    <div className="table-padding table-color-number">
                        <TextArea
                            autosize={{ minRows: 3 }}
                            className="table_numInput"
                            defaultValue={text}
                            onBlur={(e) => {
                                let value = e.target.value || "";
                                this.onChange('Comments', value, index)
                            }}
                        />
                    </div>
                )
            }
        }];
        return (
            <Spin spinning={this.state.loading} >
                <div className="table table2_1">
                    <Row className="title" id="table6_3" style={{ width: this.state.print ? 2475 : 'auto' }}>
                        <Row>6.3 C&E 3 Month Rolling Action Plan By Outlets 三个月按照餐厅细分的滚动行动计划</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true
                                    });
                                    this.getDateData(str)
                                }}
                            />
                            <Button
                                type="primary"
                                style={{ marginLeft: 10, display: this.state.print ? 'none' : '' }}
                                onClick={this.getDateData.bind(this, this.state.date, true)}
                            >填充上月数据</Button>
                        </Row>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            className="content"
                            bordered
                            pagination={false}
                            rowKey={(record, index) => {
                                return index
                            }}
                        />
                    </Row>
                    <Auth loading={this.state.loading} auth="edit_6_3">
                        <Row className="table-footer-btn">
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={this.downloadSG}
                                loading={this.state.print}
                            >加入pdf</Button>
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Row>
                    </Auth>

                </div>
            </Spin>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/6.0/6-3new/index.js